import React, { useState, useEffect } from "react";
import i18n from "@dhis2/d2-i18n";
import classes from "../../App.module.css";
import { makeStyles } from "@material-ui/core/styles";
import { apiServices } from "../../services/apiServices";
import SearchBar from "../../component/searchbar/SearchBar";
import CaseList from "./NewThemeCaseList";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import AppBar from "@material-ui/core/AppBar";
import Pagination from "@material-ui/lab/Pagination";
import Grid from "@material-ui/core/Grid";
import { useHistory } from "react-router";
import {
  Button,
  ButtonStrip,
  Divider,
  InputFieldFF,
  SingleSelectFieldFF,
  ReactFinalForm,
  hasValue,
  InputField,
  CircularLoader,
  CenteredContent,
} from "@dhis2/ui";
import { withTranslation, Trans, useTranslation } from "react-i18next";
import swal from "sweetalert";
import OfflineDb from "../../db";
import { useGlobalSpinnerActionsContext } from "../../context/GlobalSpinnerContext";
//import {Configuration} from '../../assets/data/config'
import "../../assets/css/customstyles.css";
//import '../../assets/css/theme_grey.css'
import "../../assets/css/theme_blue.css";
// import '../../assets/css/theme_green.css'
// import '../../assets/css/theme_red.css'
import _ from "lodash";
import FooterMenu from "../../component/layout/FooterMenu";
import CaseListInTableView from "./CaseListInTableView";
import moment from "moment";
import Tooltip from "@material-ui/core/Tooltip";
import CVDCalculator from "../../component/CVDCalculator/CVDCalculator";
import VisibilityIcon from "@material-ui/icons/Visibility";
import EditIcon from "@material-ui/icons/Edit";
import LocalHospitalIcon from "@material-ui/icons/LocalHospital";
import PatientCard from '../patientcard/PatientCard';
import html2canvas from 'html2canvas';
import PersonIcon from '@material-ui/icons/Person';
import CloseIcon from '@material-ui/icons/Close';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import IconButton from '@material-ui/core/IconButton';
import CardHeader from '@material-ui/core/CardHeader';
import { setTrackedEntityInstanceAction } from "../../redux/actions/action";
const { Form, Field } = ReactFinalForm;

function Cases() {
  const [sessionUserBoValue, setSessionUserBoValue] = React.useState(null);
  const [progarmData, setProgarmData] = useState(null);
  const [customSearch, setCustomSearch] = useState([]);
  const [UICSearch, setUICSearch] = useState([]);
  const [input, setInput] = useState("");
  const [patientnameinput, setPatientNameInput] = useState("");
  const [searchResult, setSearchResult] = useState([]);
  const [searchAllResult, setSearchAllResult] = useState([]);
  const [value, setValue] = useState([]);
  // const [loading,setGlobalSpinner] = useState(false)
  const { t } = useTranslation();
  const [viewType, setViweType] = useState("list");
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const history = useHistory();
  //pagination code
  //const itemsPerPage = Configuration.pagination.itemsPerPage
  const [page, setPage] = useState(1);
  const [noOfPages, setNoOfPages] = useState(0);
  const [Configuration, setConfiguration] = useState(null);
  const [openPatientCard,setOpenPatientCard] = useState(null);
  const [trackedEntityInstanceId, setTrackedEntityInstanceId] = useState(null);
  const headerName = [
    "Patient Name",
    "Gender",
    "Age",
    "Date of registration",
    "UIC",
    "phone number (permanent)",
    "instance",
  ];
  const columnHeader = [
    {
      name: t("Patient Name"),
      selector: (row) => (row["patientName"] ? row["patientName"] : "-"),
    },
    {
      name: t("Gender"),
      selector: (row) => (row["gender"] ? row["gender"] : "-"),
    },
    {
      name: t("Age"),
      selector: (row) => (row["age"] ? row["age"] : "-"),
    },
    {
      name: t("Date of registration"),
      selector: (row) =>
        row["regDate"] ? moment(row["regDate"]).format("YYYY-MM-DD") : "-",
    },
    {
      name: t("UIC"),
      selector: (row) => (row["uic"] ? row["uic"] : "-"),
    },
    {
      name: t("Contact number"),
      selector: (row) => (row["contactNumber"] ? row["contactNumber"] : "-"),
    },
    {
      name: "Edit",
      selector: (row) => row.edit,
    },
    {
      name: "View",
      selector: (row) => row.view,
    },
    {
      name: "Patient Card",
      selector: (row) => row.patientcard,
    },
    // {
    //     name: 'CDV Score',
    //     selector: row => row.cdv
    // },
  ];
  const [datatableList, setDatatableList] = useState([]);

  const [openCVDRisk, setopenCVDRisk] = useState(null);
  const [smokingId, setsmokingId] = useState(null);
  const [smoking, setsmoking] = useState(null);
  const [diabetesId, setdiabetesId] = useState(null);
  const [diabetes, setdiabetes] = useState(null);
  const [systolicBloodPressureId, setsystolicBloodPressureId] = useState(null);
  const [systolicBloodPressure, setsystolicBloodPressure] = useState(null);
  const [totalCholesterolId, settotalCholesterolId] = useState(null);
  const [totalCholesterol, settotalCholesterol] = useState(null);
  const [hdlCholesterolId, sethdlCholesterolId] = useState(null);
  const [hdlCholesterol, sethdlCholesterol] = useState(null);
  const [screeningstageId, setscreeningstageId] = useState(null);
  const [advancedinvestigationstageId, setadvancedinvestigationstageId] =
    useState(null);
  const [clietName, setclientName] = useState(null);
  const [age, setage] = useState(null);
  const [gender, setgender] = useState(null);
  const [username, setusername] = React.useState(null);
  const [userrolename, setuserrolename] = React.useState(null);


  async function getMetaData() {
    let metadata = await OfflineDb.getDataFromPouchDB("metaData");
    setProgarmData(metadata.data);

    let loginDetails = await OfflineDb.getDataFromPouchDB("loginDetails");
    setSessionUserBoValue(loginDetails.data);

    let configurations = await OfflineDb.getDataFromPouchDB("configurations");
    setConfiguration(configurations.data.configuration);
  }
  useEffect(() => {
    getMetaData();
    OfflineDb.removeDataFromPouchDB("activeCaseDetails");
    OfflineDb.removeDataFromPouchDB("activeCaseFormData");
    OfflineDb.removeDataFromPouchDB("linkContactFlag");
    OfflineDb.setDataIntoPouchDB("transferFlag", { type: null });
  }, []);

  useEffect(() => {
    if (progarmData != null) {
      getCustomVariableIds();
    }
  }, [progarmData]);

  const getCustomVariableIds = () => {
    try {
      progarmData.programs[0].programStages.map((stage) => {
        let stageName = stage.description
          ? stage.description
          : stage.displayName;
        if (stageName.trim() == "History & Screening") {
          setscreeningstageId(stage.id);
        }
        if (stageName.trim() == "Advanced Investigations") {
          setadvancedinvestigationstageId(stage.id);
        }
        stage.programStageDataElements.map((de) => {
          let fieldname = de.dataElement.description
            ? de.dataElement.description
            : de.dataElement.formName
            ? de.dataElement.formName
            : de.dataElement.displayName;
          if (fieldname) {
            if (fieldname.trim() == "Tobacco use - Smoking") {
              setsmokingId(de.dataElement.id);
            }
            if (fieldname.trim() == "History of Diabetes") {
              setdiabetesId(de.dataElement.id);
            }
            if (fieldname.trim() == "SBP at Registration") {
              setsystolicBloodPressureId(de.dataElement.id);
            }
            if (fieldname.trim() == "Total Cholesterol (mg/dl)") {
              settotalCholesterolId(de.dataElement.id);
            }
            if (fieldname.trim() == "HDL Cholesterol (mg/dl)") {
              sethdlCholesterolId(de.dataElement.id);
            }
          }
        });
      });
    } catch (e) {}
  };
  //once user bco is set call getContactList function
  useEffect(() => {
    if (sessionUserBoValue != null && Configuration != null) {
      // console.log("sessionUserBoValue.userRoles[0].name",sessionUserBoValue.userRoles[0].name)
      let userrole = sessionUserBoValue.userRoles[0].name?sessionUserBoValue.userRoles[0].name:sessionUserBoValue.userRoles[0].displayName
      setuserrolename(
        sessionUserBoValue.userRoles[0].name ||
        sessionUserBoValue.userRoles[0].displayName
      );
      setusername(sessionUserBoValue?.username)
      getCasesList(sessionUserBoValue?.username);
    }
  }, [sessionUserBoValue, Configuration]);
  useEffect(() => {
    if (searchResult.length > 0 && Configuration != null) {
      setNoOfPages(
        Math.ceil(
          searchResult[1].length / Configuration.pagination.itemsPerPage
        )
      );
    }
  }, [searchResult, Configuration]);

  function getCasesList(param) {
    //localStorage.removeItem('trackedEntityInstance')
    setGlobalSpinner(true);
    let orgID = sessionUserBoValue.organisationUnits[0].id, //`UuYrI1twhmN`,
      programID = sessionUserBoValue.programs[0], //`nSy7PFqQykt`,
      searchQuery = ``,
      roleBasedQuery = ``,
      userNameBasedQuery = ``;

      console.log("getCasesList",param)

    // for (var i in param) {
    //   searchQuery += `&attribute=${i}:LIKE:${param[i]}`;
    // }
    // roleBasedQuery = `&attribute=NXIii5Z5w6K:LIKE:${param}`;
    userNameBasedQuery = `&attribute=X4TCOW0VkbI:LIKE:${param}`;
    let subURL =
      "trackedEntityInstances/query.json?ou=" +
      orgID +
      "&ouMode=SELECTED&program=" +
      programID +
      "&pageSize=" +
      Configuration.pagination.fetchNoOfRecords +
      // roleBasedQuery + 
      userNameBasedQuery + 
      "&page=1&totalPages=false&skipPaging=true";
    //'trackedEntityInstances/query.json?ou='+ orgID +'&ouMode=SELECTED&&order=created:desc&program='+ programID +'&pageSize=50&page=1&totalPages=false'
    //&pageSize=50&page=1&totalPages=false
    apiServices
      .getAPI(subURL)
      .then((res) => {
        let searchArray = [];
        try {
          res.data.headers.map((ele) => {
            if (ele.column && progarmData) {
              let fieldBO = _.find(progarmData.trackedEntityAttributes, {
                displayName: ele.column,
              });
              if (fieldBO && ele.column != fieldBO.description) {
                ele.column = fieldBO.description;
              }
            }
          });
        } catch (e) {
          console.log(e);
        }
        searchArray.push(res.data.headers);
        //searchArray.push(res.data.rows)
        try {
          searchArray.push(res.data.rows.reverse());
        } catch (e) {
          searchArray.push(res.data.rows);
        }
        setGlobalSpinner(false);
        setSearchResult(searchArray);
        setSearchAllResult(searchArray);
        OfflineDb.setDataIntoPouchDB("myclients", searchArray);
        let filterData = [];
        const findIndexOfName = res.data.headers.findIndex(
          (obj) => obj.column.trim() == headerName[0]
        );
        const findIndexOfGender = res.data.headers.findIndex(
          (obj) => obj.column.trim() == headerName[1]
        );
        const findIndexOfAge = res.data.headers.findIndex(
          (obj) => obj.column.trim() == headerName[2]
        );
        const findIndexOfRegDate = res.data.headers.findIndex(
          (obj) => obj.column.trim() == headerName[3]
        );
        const findIndexOfUIC = res.data.headers.findIndex(
          (obj) => obj.column.trim() == headerName[4]
        );
        const findIndexOfContactNumber = res.data.headers.findIndex(
          (obj) => obj.column.trim() == headerName[5]
        );
        res.data.rows.map((ele, i) => {
          let obj = {
            patientName: ele[findIndexOfName],
            gender: ele[findIndexOfGender],
            age: ele[findIndexOfAge],
            contactNumber: ele[findIndexOfContactNumber],
            uic: ele[findIndexOfUIC],
            regDate: ele[findIndexOfRegDate],
            edit: <EditIcon onClick={(e) => UpdateRecordClick(e, ele[0])} />,
            view: (
              <VisibilityIcon
              onClick={(e) => seeIndividualRecordClick(ele[0],ele[findIndexOfName], ele[findIndexOfAge], ele[findIndexOfGender])}
              />
            ),
            cdv: (
              <LocalHospitalIcon
                onClick={(e) => getCVDRisk(ele[0], res.data.headers)}
              />
            ),
            patientcard: (
              <PersonIcon
                onClick={(e) => getPatientCard(ele[0], res.data.headers)}
              />
            ),
          };
          filterData.push(obj);
        });
        setDatatableList(filterData);
      })
      .catch((error) => {
        setGlobalSpinner(false);
        swal({
          title: "Error",
          text: navigator.onLine
            ? t("Sorry, something went wrong.")
            : t("Client list could not be shown in offline mode."),
          icon: "error",
          button: "Close",
        });
      });
  }

  function UpdateRecordClick(e, instanceuid) {
    setGlobalSpinner(true);

    const formDataMassaged = {};
    const activeCaseDetails = {
      trackedEntityInstance: instanceuid,
      enrollmentId: "",
      type: "case",
      //   "stageinstanceuid": PropsArray.stageinstanceuid,
      //   "stageuid": PropsArray.stageuid
    };
    const activeCaseFormData = {
      formFormat: null, //formDataMassaged,
      dhisFormat: null,
    };
    const linkContact = {
      enabled: false,
      linkTrackedEntityInstance: instanceuid,
    };
    OfflineDb.setDataIntoPouchDB("activeCaseDetails", activeCaseDetails);
    OfflineDb.setDataIntoPouchDB("linkContactFlag", linkContact);
    setGlobalSpinner(false);
    history.push("/layout/registration");
  }

  const seeIndividualRecordClick = (instanceuid, name, age, gender) => {
    localStorage.setItem("trackedEntityInstance", instanceuid);
    localStorage.setItem("linkContact", false);
    localStorage.setItem("hidebutton", true);

    setGlobalSpinner(true);
    console.log("1212", name)
    history.push("/layout/individualrecord", {
      trackedEntityInstance: instanceuid,
      name: name,
      age: age,
      gender: gender
    })
  };

  const getCVDRisk = (instanceId, headerEle) => {
    try {
      setsmoking(null);
      setdiabetes(null);
      setsystolicBloodPressure(null);
      sethdlCholesterol(null);
      settotalCholesterol(null);
      setGlobalSpinner(true);
      const getURL =
        "trackedEntityInstances/" +
        instanceId +
        ".json?program=" +
        progarmData.programs[0].id +
        "&fields=*?";
      apiServices.getAPI(getURL).then((res) => {
        setGlobalSpinner(false);
        const findfName = headerEle.find(
          (obj) => obj.column.trim() == headerName[0]
        );
        const findGender = headerEle.find(
          (obj) => obj.column.trim() == headerName[1]
        );
        const findAge = headerEle.find(
          (obj) => obj.column.trim() == headerName[2]
        );
        let cName = findfName
          ? _.find(res.data.attributes, { attribute: findfName["name"] })
          : "";
        let ageVal = findAge
          ? _.find(res.data.attributes, { attribute: findAge["name"] })
          : "";
        let genderVal = findGender
          ? _.find(res.data.attributes, { attribute: findGender["name"] })
          : "";
        setclientName(cName ? cName.value : "");
        setage(ageVal ? ageVal.value : "");
        setgender(genderVal ? genderVal.value : "");
        let allEvents = res.data.enrollments[0].events;
        let screeningStage = _.filter(allEvents, {
          programStage: screeningstageId,
        });
        let investigationStage = _.filter(allEvents, {
          programStage: advancedinvestigationstageId,
        });
        if (screeningStage.length > 0) {
          let dataValues = screeningStage[screeningStage.length - 1].dataValues;
          let smokingVal = _.find(dataValues, { dataElement: smokingId })
            ? _.find(dataValues, { dataElement: smokingId }).value &&
              _.find(dataValues, { dataElement: smokingId }).value == "Yes"
              ? 1
              : 0
            : null;
          let diabetesVal = _.find(dataValues, { dataElement: diabetesId })
            ? _.find(dataValues, { dataElement: diabetesId }).value &&
              (_.find(dataValues, { dataElement: diabetesId }).value == "1" ||
                _.find(dataValues, { dataElement: diabetesId }).value == "2")
              ? 1
              : 0
            : null;
          let sbpVal = _.find(dataValues, {
            dataElement: systolicBloodPressureId,
          })
            ? _.find(dataValues, { dataElement: systolicBloodPressureId }).value
            : null;
          setsmoking(smokingVal);
          setdiabetes(diabetesVal);
          setsystolicBloodPressure(sbpVal);
        }
        if (investigationStage.length > 0) {
          let investigationStagedataValues =
            investigationStage[investigationStage.length - 1].dataValues;
          let totalCholesterolVal = _.find(investigationStagedataValues, {
            dataElement: totalCholesterolId,
          })
            ? _.find(investigationStagedataValues, {
                dataElement: totalCholesterolId,
              }).value
            : null;
          let hdlCholesterolVal = _.find(investigationStagedataValues, {
            dataElement: hdlCholesterolId,
          })
            ? _.find(investigationStagedataValues, {
                dataElement: hdlCholesterolId,
              }).value
            : null;
          sethdlCholesterol(hdlCholesterolVal);
          settotalCholesterol(totalCholesterolVal);
        }
        setTimeout(function () {
          setopenCVDRisk(true);
        }, 500);
      });
    } catch (e) {}
  };

  function getPatientCard(instanceId){
    //history.push('/layout/patientcard',{"trackedEntityInstance": row.row[0]})
    setOpenPatientCard(true)
    setTrackedEntityInstanceId(instanceId)
  }

  function printQRCards() {
    
    var contents = document.getElementById("printQRDiv").innerHTML;
    var frame1 = document.createElement('iframe');
    frame1.name = "frame1";
    frame1.style.position = "absolute";
    // frame1.style.top = "-1000000px";
    document.body.appendChild(frame1);
    var frameDoc = frame1.contentWindow ? frame1.contentWindow : frame1.contentDocument.document ? frame1.contentDocument.document : frame1.contentDocument;
    frameDoc.document.open();
    frameDoc.document.write(`<html><head><title>Patient Card</title>`);
    frameDoc.document.write(`
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.1.0/dist/css/bootstrap.min.css" integrity="sha384-KyZXEAg3QhqLMpG8r+8fhAXLRk2vvoC2f3B09zVXn8CA5QIVfZOJ3BCsw2P0p/We" crossorigin="anonymous" />
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.3/css/all.min.css" integrity="sha512-iBBXm8fW90+nuLcSKlbmrPcLa0OT92xO1BIsZ+ywDWZCvqsWgccV3gFoRBv0z+8dLJgyAHIhR35VZc2oM/gI1w==" crossorigin="anonymous" />
    </head><body>`);
    //frameDoc.document.write('<link href="../assets/css/card.css" rel="stylesheet" type="print" />');
    frameDoc.document.write(contents);
    frameDoc.document.write(`</body>
    <style>
        @media print {
            .makeStyles-root-38 {
                width: 100%;
                max-width: 500px;
            }

            .MuiAvatar-root{
              border-radius: 0;
              width: 100px;
              height: 100px;
              margin-right: 20px;
          }

            .MuiCard-root{
                border: 1px solid #ccc; !important;
            }

            .MuiGrid-container{
                display: flex;
                flex-wrap: wrap;
                box-sizing: border-box;
            }

            .MuiCardHeader-root {
                display: flex;
                padding: 16px;
                align-items: center;
            }

            .MuiCardHeader-avatar {
                flex: 0 0 auto;
                margin-right: 16px;
            }
            .MuiCardHeader-content span {
                color: #000;
                font-size: 20px;
                font-weight: bold;
            }

            .logobg {
                  width: 100px;
                  height: 100px;
                  background-repeat: no-repeat;
                  background-size: contain;
                  margin-top: 31px;
            }
            .alerts_description_fields {
                padding-left: 5px;
            }
            .MuiTypography-displayBlock {
                display: block;
            }
            .MuiTypography-body2 {
                
                font-family: IBM Plex Sans;
                
                line-height: 1.43;
            }

            .MuiCardHeader-subheader {
                font-size: 14px !important;
                color: gray !important;
            }
            .MuiCardContent-root {
                padding: 16px;
            }

            .MuiCardContent-root:last-child {
                padding-bottom: 24px;
            }

            .pT0 {
                padding-top: 0px !important;
            }

            .alerts_description_fields{
                font-size: 20px;
            }

            .alerts_description_fields {
                font-size: 0.875rem;
                font-family: IBM Plex Sans;
                font-weight: 400;
                line-height: 1.43;
                color: #212529;
                margin: 10px 0px;
            }

            .alerts_description_fields{
                font-size: 20px;
            }
            body, .MuiTypography, button, .MuiTypography-body1 {
                font-family: 'Open Sans', sans-serif !important;
            }

            .MuiGrid-spacing-xs-3 {
                width: calc(100% + 24px);
                margin: -12px;
            }

            .MuiGrid-container {
                width: 100%;
                display: flex;
                flex-wrap: wrap;
                box-sizing: border-box;
            }

            .MuiGrid-grid-sm-8 {
                flex-grow: 0;
                max-width: 66.666667%;
                flex-basis: 66.666667%;
            }

            .MuiGrid-grid-xs-8 {
                flex-grow: 0;
                max-width: 66.666667%;
                flex-basis: 66.666667%;
            }

            .MuiGrid-grid-md-4 {
                flex-grow: 0;
                max-width: 33.333333%;
                flex-basis: 33.333333%;
            }
            .MuiGrid-grid-xs-7 {
              flex-grow: 0;
              max-width: 58.333333%;
              flex-basis: 58.333333%;
          }
            .MuiGrid-grid-xs-5 {
              flex-grow: 0;
              max-width: 41.666667%;
              flex-basis: 41.666667%;
          }

          .MuiGrid-spacing-xs-3 > .MuiGrid-item {
            padding: 12px;
          }
        }
</style>
   <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.1.1/dist/js/bootstrap.bundle.min.js" integrity="sha384-/bQdsTh/da6pkI1MST/rWKFNjaCP5gBSY4sEBT38Q/9RBh9AH40zEOg7Hlq2THRZ" crossorigin="anonymous"></script></html>`);
    frameDoc.document.close();
    console.log(frameDoc)
    setTimeout(function () {
      window.frames["frame1"].focus();
      window.frames["frame1"].print();
      document.body.removeChild(frame1);
    }, 1000);
    //setOpenPatientCard(false)
    return false;
  }

  function shareQRCards(){
    //setGlobalSpinner(true)
    html2canvas(document.querySelector('#printQRDiv'), {
        allowTaint: true,
        useCORS: true,
      }).then(canvas => {
        setGlobalSpinner(false)
        //const imageScreen = new Image();
        //imageScreen.src = canvas.toDataURL();
        //console.log("canvas ",canvas,canvas.toDataURL('image/jpeg'));
        //imageScreen.onload = () => setiscreenshotContinue(imageScreen)
        window.plugins.socialsharing.share(null, null, canvas.toDataURL('image/png'), null)
      }).catch(error=>{
        setGlobalSpinner(false)
      });
  }

  function renderPatientCard(){
    return(
      <div className="modaloverlay">
        <div className="modalcardholder">
            <Card className="modalcard">
                <CardHeader
                    className="modalheader"
                    action={
                        <IconButton aria-label="close">
                            <CloseIcon onClick={() => setOpenPatientCard(false)} />
                        </IconButton>
                    }
                    title={"Patient Card"}
                />
                <CardContent className="modalbodycontent">
                  <PatientCard trackedEntityInstance={trackedEntityInstanceId}></PatientCard>
                </CardContent>
                <CardActions className="modalfooter">
                  {window.cordova ? 
                    <Button className="modalactionbtn" onClick={() => shareQRCards()}>Share</Button>
                  :
                    <Button className="modalactionbtn" onClick={() => printQRCards()}>Print</Button>
                  }     
                    <Button className="modalactionbtn" onClick={() => setOpenPatientCard(false)}>Cancel</Button>
                </CardActions>
            </Card>
        </div>
    </div>  
    )
  }

  const handleViewChange = (event, newValue) => {
    setViweType(newValue);
  };

  const updateInput = (input) => {
    setInput(input);
    let filteredList = [];
    setGlobalSpinner(true);
    if (input && input.length > 3) {
      searchAllResult[1].map(function (objectKey, index) {
        objectKey.map(function (data, j) {
          if (data.toLowerCase().indexOf(input.toLowerCase()) > -1) {
            filteredList.push(objectKey);
          }
        });
      });
      let headerEle = searchAllResult[0];
      let filterSearchArray = [];
      filterSearchArray.push(headerEle);
      filterSearchArray.push(filteredList);
      setSearchResult([]);
      setTimeout(function () {
        setGlobalSpinner(false);
        setSearchResult(filterSearchArray);
      }, 500);
    } else {
      if (input.length == 0) {
        let headerEle = searchAllResult[0];
        let filterSearchArray = [];
        filterSearchArray.push(headerEle);
        filterSearchArray.push(searchAllResult[1]);
        setSearchResult([]);
        setTimeout(function () {
          setGlobalSpinner(false);
          setSearchResult(filterSearchArray);
        }, 1000);
      } else {
        setGlobalSpinner(false);
      }
    }

    //if(filteredList.length > 0){
  };

  const updatePatientName = (patientnameinput) => {
    setPatientNameInput(patientnameinput);
    let filteredList = [];
    let headerEle = searchAllResult[0];
    const findIndexOfName = headerEle.findIndex(
      (obj) => obj.column.trim() == headerName[0]
    );
    const findIndexOfGender = headerEle.findIndex(
      (obj) => obj.column.trim() == headerName[1]
    );
    const findIndexOfAge = headerEle.findIndex(
      (obj) => obj.column.trim() == headerName[2]
    );
    const findIndexOfRegDate = headerEle.findIndex(
      (obj) => obj.column.trim() == headerName[3]
    );
    const findIndexOfUIC = headerEle.findIndex(
      (obj) => obj.column.trim() == headerName[4]
    );
    const findIndexOfContactNumber = headerEle.findIndex(
      (obj) => obj.column.trim() == headerName[5]
    );
    setGlobalSpinner(true);
    if (patientnameinput && patientnameinput.length > 2) {
      searchAllResult[1].map(function (objectKey, index) {
        objectKey.map(function (data, j) {
          if (
            (findIndexOfName == j &&
              data.toLowerCase().indexOf(patientnameinput.toLowerCase()) >
                -1) ||
            (findIndexOfUIC == j &&
              data.toLowerCase().indexOf(patientnameinput.toLowerCase()) >
                -1) ||
            (findIndexOfContactNumber == j &&
              data.toLowerCase().indexOf(patientnameinput.toLowerCase()) > -1)
          ) {
            filteredList.push(objectKey);
          }
        });
      });
      let filterData = [];
      filteredList.map((ele, i) => {
        let obj = {
          patientName: ele[findIndexOfName],
          gender: ele[findIndexOfGender],
          age: ele[findIndexOfAge],
          contactNumber: ele[findIndexOfContactNumber],
          uic: ele[findIndexOfUIC],
          regDate: ele[findIndexOfRegDate],
          edit: <EditIcon onClick={(e) => UpdateRecordClick(e, ele[0])} />,
          view: (
            <VisibilityIcon  onClick={(e) => seeIndividualRecordClick(ele[0],ele[findIndexOfName], ele[findIndexOfAge], ele[findIndexOfGender])}
            />
          ),
          cdv: (
            <LocalHospitalIcon
              onClick={(e) => getCVDRisk(ele[0], searchAllResult[0])}
            />
          ),
          patientcard: (
            <PersonIcon
              onClick={(e) => getPatientCard(ele[0], searchAllResult[0])}
            />
          ),
        };
        filterData.push(obj);
      });
      setDatatableList([]);
      setTimeout(function () {
        setGlobalSpinner(false);
        setDatatableList(filterData);
      }, 500);
    } else {
      if (patientnameinput.length == 0) {
        let filterData = [];
        searchAllResult[1].map((ele, i) => {
          let obj = {
            patientName: ele[findIndexOfName],
            gender: ele[findIndexOfGender],
            age: ele[findIndexOfAge],
            contactNumber: ele[findIndexOfContactNumber],
            uic: ele[findIndexOfUIC],
            regDate: ele[findIndexOfRegDate],
            edit: <EditIcon onClick={(e) => UpdateRecordClick(e, ele[0])} />,
            view: (
              <VisibilityIcon
                onClick={(e) => seeIndividualRecordClick(ele[0],ele[findIndexOfName], ele[findIndexOfAge], ele[findIndexOfGender])}
              />
            ),
            cdv: (
              <LocalHospitalIcon
                onClick={(e) => getCVDRisk(ele[0], searchAllResult[0])}
              />
            ),
            patientcard: (
              <PersonIcon
                onClick={(e) => getPatientCard(ele[0], searchAllResult[0])}
              />
            ),
          };
          filterData.push(obj);
        });
        setDatatableList([]);
        setTimeout(function () {
          setGlobalSpinner(false);
          setDatatableList(filterData);
        }, 500);
      } else {
        setGlobalSpinner(false);
      }
    }

    //if(filteredList.length > 0){
  };
  const loadViewToggleButtons = () => {
    return (
      <div className=" customregistrationtabs regcasetabs ">
        <AppBar position="static">
          <Tabs value={viewType} onChange={handleViewChange}>
            <Tab value="list" label={t("List View")}></Tab>
            <Tab value="card" label={t("Card View")}></Tab>
          </Tabs>
        </AppBar>
      </div>
    );
  };
  const handlePageChange = (event, value) => {
    setPage(value);
  };
  return (
    <section
      className="searchcustombg searchtabmaindiv myclientspage"
      style={{
        // backgroundColor: '#fff',
        flexGrow: 1,
        padding: 0,
      }}
    >
      <FooterMenu></FooterMenu>
      <div className="searchformcontainer patientlistsection">
        <p className="searchformheading">
          <span>
            <Trans>My Clients</Trans>
          </span>
        </p>

        {window.cordova && <SearchBar input={input} setKeyword={updateInput} />}
        {window.cordova ? (
          searchResult.length > 0 &&
          progarmData != null &&
          Configuration != null ? (
            <>
              <CaseList
                searchResult={searchResult}
                viewType={viewType}
                metaData={progarmData}
                page={page}
                itemsPerPage={Configuration.pagination.itemsPerPage}
              />
              <Pagination
                count={noOfPages}
                page={page}
                onChange={handlePageChange}
                defaultPage={1}
                //color="primary"
                size="large"
                showFirstButton
                showLastButton
                variant="outlined"
                shape="rounded"
              />
            </>
          ) : null
        ) : searchResult.length > 0 &&
          progarmData != null &&
          Configuration != null ? (
          <>
            <Grid container spacing={3}>
              {/* <Grid item xs={2}>Search:</Grid> */}
              <Grid item xs={12}>
                <Tooltip
                  title={t("Search by Patient Name / UIC / Contact number")}
                  arrow
                >
                  <SearchBar
                    input={patientnameinput}
                    setKeyword={updatePatientName}
                    placeholder={
                      "Search By: Patient Name / UIC / Contact number"
                    }
                  />
                </Tooltip>
              </Grid>
              {/* <Grid item xs={3}>
                            <SearchBar 
                                input={input} 
                                setKeyword={updateConatctNumber}
                                placeholder={"Contact Number"}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <SearchBar 
                                input={input} 
                                setKeyword={updateUIC}
                                placeholder={"UIC"}
                            />
                        </Grid> */}
            </Grid>
            <CaseListInTableView columns={columnHeader} data={datatableList} />
          </>
        ) : null}
      </div>
      {openCVDRisk && searchResult.length > 0 ? (
        <CVDCalculator
          name={clietName}
          age={age}
          gender={gender ? gender.toLowerCase() : ""}
          smoking={smoking}
          diabetes={diabetes}
          systolicBloodPressure={systolicBloodPressure}
          totalCholesterol={totalCholesterol}
          hdlCholesterol={hdlCholesterol}
          setopenCVDRisk={setopenCVDRisk}
        />
      ) : (
        <></>
      )}
      {openPatientCard && trackedEntityInstanceId ? renderPatientCard() : <></>}
    </section>
  );
}
export default Cases;
